import { useFlags } from '~/hooks/utils/launchDarklyInterceptor';

/**
 * Flags that are temporary and should be removed after a certain date.
 *
 * If you need are adding a permanent flag, add it to `useFlags` instead.
 */
export type TemporaryFeatureFlags = {
  /**
   * Added on October 22, 2025
   * This flag enables performance analytics for the workspace. Should be replaced by addOn
   */
  performanceAnalytics: boolean;

  /**
   * Added on December 16, 2025
   * This flag enables select all functionality for bulk operations
   */
  selectAllEnabled: boolean;

  /**
   * Added on January 22, 2026
   * This flag enables the player editor for video clips
   */
  playerEditor: boolean;
  /**
   * Added on January 29, 2026
   * This flag enables the canvas editor features
   */
  generativeCanvasEnabled: boolean;
  /**
   * Added on February 23, 2026
   * This flag enables CSV download of an asset's custom field data
   * @TODO(PLA-955): Remove after rollout
   */
  customFieldsCsvDownload: boolean;
  /**
   * Added on March 16, 2026
   * This flag enables credit usage stats for legacy plans
   * @TODO(AI-1041): Remove after rollout
   */
  creditUsageEnabledForLegacyPlans: boolean;

  /**
   * Added on March 19, 2026
   * This flag enables the canvas edit elements feature
   * @TODO(AI-1157): Remove after rollout
   */
  canvasEditElementsEnabled: boolean;

  /**
   * Added on April 27, 2026
   * This flag enables the skills UI
   * @TODO(AI-1523): Remove after rollout
   */
  enableSkillsUi: boolean;

  /**
   * Added on April 30, 2026
   * This flag enables the team invite step experiment in onboarding
   * @TODO(COR-1823): Remove after experiment
   */
  onboardingTeamInviteStepEnabled: boolean;
};

export const useTemporaryFeatureFlags = () => {
  return useFlags<TemporaryFeatureFlags>();
};
